import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { changeChecked } from "../../features/filter/filterSlice";
import { useGetProjectsQuery } from "../../features/projects/projectsApi";

const ProjectsList = () => {
  const dispatch = useDispatch();

  const { checked } = useSelector((state) => state.filter);

  const { data: projects } = useGetProjectsQuery();
  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">
        {projects?.map((project) => (
          <div key={project.id} className="checkbox-container">
            <input
              type="checkbox"
              className={project.colorClass}
              onChange={() => dispatch(changeChecked(project.projectName))}
              checked={checked.includes(project.projectName)}
            />
            <p className="label">{project.projectName}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectsList;
